import React from "react"
import { createPortal } from "react-dom"
import DirectChatWindow from "./DirectChatWindow"
import { useChatDock } from "./ChatDockProvider"

const DirectChatDock = () => {
  const { openChats } = useChatDock()
  if (typeof document === "undefined" || openChats.length === 0) return null

  return createPortal(
    <div className="direct-chat-dock" aria-label="Direct chats">
      {openChats.map(contact => (
        <DirectChatWindow key={contact.id} contact={contact} />
      ))}
    </div>,
    document.body
  )
}

export default DirectChatDock
